<template>
  <div class="page">
    <BookingBack title="Gift Card" :textColor="'#333333'" :isCenter="true" />
    <div class="success-content">
      <!-- 成功图标 -->
      <div class="success-icon">
        <van-icon name="success" size="40" color="#fff" />
      </div>
      <div class="success-text">Payment Successful</div>
      <!-- Gift Card信息卡片：已购买状态，显示卡号 -->
      <div class="card-wrapper">
        <MyCard :card="cardForMyCard" :clickable="false" />
      </div>
    </div>
    <!-- 底部按钮 -->
    <OrderBtn>
      <div class="success-actions">
        <div class="view-cards-btn" @click="goToMyGiftCards">View My Gift Cards</div>
        <div class="copy-card-btn" @click="copyCardNo">Copy Card Number</div>
      </div>
    </OrderBtn>
    <div class="share-tip">Keep your card number and PIN secure. Your PIN is available in My Gift Cards.</div>
  </div>
</template>
<script>
import BookingBack from '@/components/Booking/back.vue'
import OrderBtn from '@/components/Order/btn.vue'
import MyCard from '@/components/GiftCard/MyCard.vue'
import { Toast } from 'vant'
const SS_PAYMENT_HANDLED = 'giftcard_payment_handled'
export default {
  name: 'GiftCardSuccess',
  components: { BookingBack, OrderBtn, MyCard },
  data() {
    return {
      cardInfo: {
        id: '',
        card_no: '',
        name: '',
        price: 0,
        value: 0,
        shopName: '',
        shopLogo: '',
        applicable_scope: 0
      }
    }
  },
  computed: {
    cardForMyCard() {
      return {
        id: this.cardInfo.id,
        number: this.cardInfo.card_no,
        storeName: this.cardInfo.name || this.cardInfo.shopName || 'Gift Card',
        address: '',
        amount: this.cardInfo.value || this.cardInfo.price || 0,
        bg: 1,
        cardImage: this.shopLogo !== 'https://pic.rmb.bdstatic.com/bjh/bc11504608c0/250314/7904a9d0b5755cec95a4bb00d8763f94.png' ? '' : ''
      }
    },
    scopeText() {
      const scope = Number(this.cardInfo.applicable_scope)
      if (scope === 0) return 'All Services & Products'
      if (scope === 1) return 'Selected Services Only'
      return 'See Merchant Details'
    },
    shopLogo() {
      const logo = this.cardInfo.shopLogo
      if (!logo) {
        return 'https://pic.rmb.bdstatic.com/bjh/bc11504608c0/250314/7904a9d0b5755cec95a4bb00d8763f94.png'
      }
      return this.formatImagePath(logo)
    }
  },
  created() {
    this.initCardInfo()
    // Clear the payment handled flag so user can purchase another gift card later
    try { sessionStorage.removeItem(SS_PAYMENT_HANDLED) } catch (e) {}
  },
  methods: {
    formatImagePath(path) {
      if (!path) return ''
      let finalPath = path.trim()
      if (/^https?:/i.test(finalPath)) {
        return finalPath.replace('http://localhost:8080', 'http://www.hwm.red')
      }
      finalPath = finalPath.replace(/^\/+/, '')
      return `http://www.hwm.red/${finalPath}`
    },
    initCardInfo() {
      const query = this.$route.query
      this.cardInfo = {
        id: query.id || '',
        card_no: query.card_no || '',
        name: query.name || 'Shampoo & Style',
        price: query.price || 55,
        value: query.value || 55,
        shopName: query.shop_name || 'Honey K\'s Salon',
        shopLogo: query.shop_logo || '',
        applicable_scope: query.scope || 0
      }
    },
    formatPrice(val) {
      const num = Number(val || 0)
      return num.toFixed(2)
    },
    copyCardNo() {
      const text = this.cardInfo.card_no
      if (!text) {
        Toast('No card number')
        return
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          Toast.success('Card number copied')
        })
      } else {
        const input = document.createElement('input')
        input.value = text
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        Toast.success('Card number copied')
      }
    },
    // 使用 replace 避免用户返回支付完成页后再次进入支付回跳链路。
    goToMyGiftCards() {
      this.$router.replace({ path: '/myGiftCard' })
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  min-height: 100vh;
  background: #fff;
}
.success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem;
}
.success-icon {
  width: 70px;
  height: 70px;
  background: #2DB87E;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}
.success-text {
  font-size: 1.125rem;
  color: #333;
  font-weight: 500;
  margin-bottom: 1.5rem;
}
.card-wrapper {
  width: 100%;
  padding: 0 0.5rem;
  box-sizing: border-box;
}
.success-actions {
  width: 100%;
}
.view-cards-btn {
  height: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  background: #1a3a2f;
  color: #fff;
  font-size: 0.9375rem;
  font-weight: 600;
}
.copy-card-btn {
  margin-top: 0.5rem;
  color: #1a3a2f;
  font-size: 0.875rem;
  text-align: center;
}
.share-tip {
  text-align: center;
  color: #999;
  font-size: 0.75rem;
  margin: 0.5rem 1rem 1rem;
}
</style>
